export default __webpack_public_path__ + "static/map-bd37000e4dd2c16011dc42d013c3ab69.png";